import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse,HttpResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';

const apiUrl = GlobalConstants.apiURL
const openapiUrlServ = GlobalConstants.openApiURL

@Injectable({
  providedIn: 'root'
})
export class LeadsService {

    constructor(private http:HttpClient, private sharedapi:SharedService) { }

    getLeads(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-leads/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    getPartnerLeads(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-leads-partners-export/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    getleaddumpByDate(qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(openapiUrlServ+'get-leads-dump-by-date?'+qstring,{headers:webheader})
    }

    getLeadsSheet(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-leads-sheet/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    getRecordingLogs(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-recording-logs/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    getCommonData()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-common-data',{headers:webheader})
    }

    getLeadStatus()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lead-status',{headers:webheader})
    }

    getbds(status=1)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-bds/'+status,{headers:webheader})
    }

    getbdsExcludingDental(status=1)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-bds-excluding-dental/'+status,{headers:webheader})
    }

    getbdsForGlamyoPartners(status=1)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-bds-glamyo-partners/'+status,{headers:webheader})
    }

    clickTOCall(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'click-to-call',lead_id,{headers:webheader})
    }

    endClicktoCall(response_call_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'end-click-to-call',response_call_id,{headers:webheader})
    }

    nimbusClickTOCall(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'nimbus-click-to-call',lead_id,{headers:webheader})
    }

    getbdsOfInsurance(role=5)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-user-by-role/'+role,{headers:webheader})
    }

    getbdsofCorporate(status=1)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-bds-of-corporate/'+status,{headers:webheader})
    }

    getTreatCatwisebds(qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-treat-cat-wise-bds?'+qstring,{headers:webheader})
    }

    getcirclewisebds(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-circle-wisebd?'+data,{headers:webheader})
    }

    getcatcirclewisebds(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-cat-circle-wisebd?'+data,{headers:webheader})
    }

    getAllBds($type)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-all-bds/'+$type,{headers:webheader})
    }

    getCircleOfCity(city_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-circle-by-city/'+city_id,{headers:webheader})
    }

    getdoctors()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-doctors',{headers:webheader})
    }

    gettreatdoctors(circle_id,treatment_id,docId)
    {
        let webheader = this.sharedapi.getHeaders();
        if(docId){
            return this.http.get(apiUrl+'get-doctors-treatwise-circle/'+circle_id+'/'+treatment_id+'/'+docId,{headers:webheader})
        }
        return this.http.get(apiUrl+'get-doctors-treatwise-circle/'+circle_id+'/'+treatment_id,{headers:webheader})
    }


    gethospitals()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-hospitals',{headers:webheader})
    }

    gethospitalCircleWiseListing(circle_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-hospital-circle-wise-list/'+circle_id,{headers:webheader})
    }

    getInsuranceCompanyList()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-ins-company-list',{headers:webheader})
    }

    getlabs()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-labs',{headers:webheader})
    }

    getcircles()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-circle',{headers:webheader})
    }

    getLeadSources()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lead-sources',{headers:webheader})
    }

    getUpdatedLeadSources(url)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-updated-lead-sources/'+url,{headers:webheader})
    }

    getPartnerLeadSources()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-partner-lead-sources',{headers:webheader})
    }

    getBridgeNumberLists()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-bridge-numbers',{headers:webheader})
    }

    getUserRoles()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-all-roles',{headers:webheader})
    }

    getcities()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-cities',{headers:webheader})
    }

    getTreatments()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-treatment',{headers:webheader})
    }

    getTls()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-tls',{headers:webheader})
    }

    getTlsForUser()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-tls-for-user',{headers:webheader})
    }

    getCms()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-cms',{headers:webheader})
    }

    updateSheetData(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'save-sheet-data',data,{headers:webheader})
    }

    getDashboardCount()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-dashboard-data',{headers:webheader})
    }

    getDashboardDentalCount()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-dashboard-dental-data',{headers:webheader})
    }

    getDashboardAllCount(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-dashboard-count?'+data,{headers:webheader})
    }

    getDashboardUserOpd_Ipd(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-dashboard-user-opd-ipd-count?'+data,{headers:webheader})
    }

    getCircleCount(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-circle-count?'+data,{headers:webheader})
    }

    getUsersLeadCount(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-users-lead-count?'+data,{headers:webheader})
    }

    updateSingleData(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'save-single-data',data,{headers:webheader})
    }

    updateSingleDataInsuranceBd(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'save-single-data-insurance',data,{headers:webheader})
    }

    saveCrossBDData(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'save-crossbd-data',data,{headers:webheader})
    }

    uploadcsv(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-leads-csv',data,{headers:webheader})
    }

    uploadcsvFb(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-leads-fb',data,{headers:webheader})
    }

    uploadcsvPartners(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-corporate-partner-lead-csv',data,{headers:webheader})
    }

    uploadcsvRetail(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-leads-retail',data,{headers:webheader})
    }

    uploadcsvCorporateFb(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-leads-corporate-fb',data,{headers:webheader})
    }

    uploadcsvLeadStatusUpdate(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-leads-status-update-csv',data,{headers:webheader})
    }

    uploadcsvOfScanbookAssignedtoSpokUpdate(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-assigned-scanbook-to-spok',data,{headers:webheader})
    }

    uploadcsvIPDPxAssignedTo(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-ipd-px-assigned-to',data,{headers:webheader})
    }

    getLeadHistory(lead_id,pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lead-history/'+lead_id+'/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    getFullLeadHistory(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-full-lead-history/'+lead_id,{headers:webheader})
    }

    getFullInsuranceLeadHistory(insurance_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-full-insurance-lead-history/'+insurance_id,{headers:webheader})
    }

    getLeadDetail(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lead-details/'+lead_id,{headers:webheader})
    }

    getLeadUpdateDetail(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lead-update-details/'+lead_id,{headers:webheader})
    }

    //Insurance services
    getInsuranceDetails(data)
    {
        let lead_id = data.lead_id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-insurance-details/'+lead_id,{headers:webheader})
    }

    getPreAuthInsuranceDetails(data, sheetview_action)
    {
        let lead_id = data.lead_id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-preauth-insurance-details/'+lead_id+'/'+sheetview_action,{headers:webheader})
    }

    uploadInsuranceFile(data,formData)
    {
        let lead_id = data.lead_id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'upload-insurance-doc/'+lead_id,formData,{headers:webheader})
    }

    updateInsurancDetails(data,formData)
    {
        let lead_id = data.lead_id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'update-insurance-details/'+lead_id,formData,{headers:webheader})
    }

    getInsuranceList(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-insurance-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    getInsuranceListForTracking(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-insurance-list-for-tracking/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    //opd services
    getOpdDetails(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-opd-details/'+data.lead_id,{headers:webheader})
    }


    viewOpdDetails(opd_id)
    {
        //console.log(opd_id);
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'view-opd/'+opd_id,{headers:webheader})
    }

    updateOpd(data,OpdData)
    {
        let lead_id = data.lead_id;
        var formData: any = new FormData();
        for (const key in OpdData)
        {
            if(key=='appointment_date' || (key=='followup_date' && OpdData[key]))
            {
                formData.append(key, OpdData[key].getFullYear()+'-'+(OpdData[key].getMonth()+1)+'-'+OpdData[key].getDate());
            }else{
            formData.append(key, OpdData[key]);
            }
        }
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-opd/'+lead_id,formData,{headers:webheader})
    }

    uploadOpdFile(data,formData)
    {
        let lead_id = data.lead_id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'upload-case-paper/'+lead_id,formData,{headers:webheader})
    }

    getOpds(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-opds/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    changeStatus(opd_id,status)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'update-status/'+opd_id+'/'+status,{},{headers:webheader})
    }

    /* sendOpdReviewLink(opd_id)
    {
        
    } */


    //ipd services
    getIpdDetails(data)
    {
        let lead_id = data.lead_id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-ipd-details/'+lead_id,{headers:webheader})
    }

    viewIpdDetails(ipd_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'view-ipd/'+ipd_id,{headers:webheader})
    }

    updateIpd(data,IpdData)
    {
        let lead_id = data.lead_id;
        var formData: any = new FormData();
        for (const key in IpdData)
        {
            if((key=='surgery_date' || key=='pickup_date') && IpdData[key] != null)
            {
                formData.append(key, IpdData[key].getFullYear()+'-'+(IpdData[key].getMonth()+1)+'-'+IpdData[key].getDate());
            }else
            formData.append(key, IpdData[key]);
        }

        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-ipd/'+lead_id,formData,{headers:webheader})
    }

    updatePreauthData(data,IpdData)
    {
        let lead_id = data.lead_id;
        var formData: any = new FormData();
        for (const key in IpdData)
        {
            formData.append(key, IpdData[key]);
        }

        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-preauth-data/'+lead_id,formData,{headers:webheader})
    }

    uploadIpdFile(data,formData)
    {
        let lead_id = data.lead_id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'upload-ipd-docs/'+lead_id,formData,{headers:webheader})
    }

    getIpds(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-ipds/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    changeStatusIpd(ipd_id,status)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'update-status-ipd/'+ipd_id+'/'+status,{},{headers:webheader})
    }

    getInsuranceCount()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-dashboard-data-insurance',{headers:webheader})
    }

    addLead(data){
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-lead',data,{headers:webheader})
    }

    getcirclescities(){
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-circle-cities',{headers:webheader})
    }

    updateCircleCities(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-circle-cities',data,{headers:webheader})
    }

    getHDShares(data){
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'get-hd-treatCost-data',data, {headers:webheader})
    }

    getIpdResourcesList(type)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-IpdResources-dropvalue/'+type ,{headers:webheader})
    }

    IpdUsedResource(data){
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-ipd-used-resource',data,{headers:webheader})
    }

    fetchUsedResource(data){
        let ipd_id = data;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-used-resource/'+ipd_id,{headers:webheader})
    }

    deleteIpdFiles(fileId)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.delete(apiUrl+'delete-file/'+fileId,{headers:webheader})
    }

    deleteInsuranceFiles(fileId)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.delete(apiUrl+'delete-file-insurance/'+fileId,{headers:webheader})
    }

    deleteOpdFiles(fileId)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.delete(apiUrl+'delete-file-opd/'+fileId,{headers:webheader})
    }

    getTodayAdmissiondischarge()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-admission-discharge-count',{headers:webheader})
    }

    copyLeadData(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'copy-lead-data/'+lead_id,{headers:webheader})
    }

    UpdateIpdUsedResource(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'save-single-ipd-usedresource-data',data,{headers:webheader})
    }

    updatePatientId()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'update-patient-Id',{headers:webheader})
    }

    updateOpdDocsStatus(recid,data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-opd-docs-status/'+ recid ,data,{headers:webheader})
    }

    updateIpdDocsStatus(recid,data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-ipd-docs-status/'+ recid ,data,{headers:webheader})
    }

    getDashboardDoctorsOpd_Ipd(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-dashboard-doctors-opd-ipd-count?'+data,{headers:webheader})
    }

    getTodayIpdList()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-today-opd-list',{headers:webheader})
    }

    getInsuranceCardTatList(data:any)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-insurance-card-tat-list?'+data, {headers:webheader});
    }

    updateAssignee(userId:number, insuranceId:number)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.patch(apiUrl+'update-insurance-assignee/'+insuranceId, {userId:userId}, {headers:webheader});
    }

    getUserLeadsTatList()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-user-lead-tat-list', {headers:webheader});
    }

    viewBilledAmountDetails(ipd_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'view-ipd-billed-detail/'+ipd_id,{headers:webheader})
    }

    viewOpdHistroyDetails(opd_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'view-opd-history/'+opd_id,{headers:webheader})
    }

    getInsuranceCardData()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-insurance-card-data', {headers:webheader});
    }

    getLeadHistories(pageno,limit,qstring)
    {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-lead-histories/'+limit+'/'+pageno+'?'+qstring, {headers:webheader});
    }

    getLocations(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-location?'+data,{headers:webheader})
    }

    getTreatmentCategorywise(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-category-wise-treatment?'+data,{headers:webheader})
    }

    getPaymentStat(data){
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-payment-stats?'+ data, {headers:webheader});
    }

    getPaymentStatCatWise(data){
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-payment-stats-catergory-wise?'+ data, {headers:webheader});
    }

    getpaymenttreatmentStatus(data){
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-payment-treatment-status/'+ data, {headers:webheader});
    }

    addDnpFollowUpData(data){
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-dnp-followup-data',data,{headers:webheader})
    }

    showDNPFollow_Detail(data){
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-dnp-followup-detail/'+ data, {headers:webheader});
    }

    getInsuranceCardReport()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-insurance-report', {headers:webheader});
    }
    
    getInsuranceCardHistoryReport(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-insurance-report-of-pre-auth-approval-final?'+data, {headers:webheader});
    }

    checkDnpFollowUpDataExist(leadId,status,type)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'check-dnp-follow-data/'+leadId+'/'+status+'/'+type, {headers:webheader});
    }

    getTreatmentCategoryReport()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-treatment-category-report', {headers:webheader});
    }

    createSecondDiseaseIpd(lead_id:number,ipd_id:number)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'create-second-disease-ipd/'+lead_id+'/'+ipd_id,{headers:webheader})
    }

    getMeetingRoomList()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-meeting-room-lists', {headers:webheader});
    }

    addMeetingRoomBooking(data){
        let webheader = this.sharedapi.getHeaders();
        var formData: any = new FormData();
        for (const key in data)
        {
            if((key=='booking_date') && data[key] != null)
            {
                formData.append(key, data[key].getFullYear()+'-'+(data[key].getMonth()+1)+'-'+data[key].getDate());
            }else
            formData.append(key, data[key]);
        }
        return this.http.post(apiUrl+'add-meeting-room-booking',formData,{headers:webheader})
    }

    getEndTime(from_time)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-end-time-for-meeting-room/'+from_time,{headers:webheader});
    }

    getMeetingRoomBookedFormData(meeting_room_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-booked-meeting-room-form-data/'+meeting_room_id,{headers:webheader});
    }

    updateMeetingRoomBooking(data)
    {
        let webheader = this.sharedapi.getHeaders();
        var formData: any = new FormData();
        for (const key in data)
        {
            if((key=='booking_date') && data[key] != null)
            {
                formData.append(key, data[key].getFullYear()+'-'+(data[key].getMonth()+1)+'-'+data[key].getDate());
            }else
            formData.append(key, data[key]);
        }
        return this.http.post(apiUrl+'update-meeting-room-booking',formData,{headers:webheader})
    }

    getBookedMeetingRooms(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-booked-meeting-room/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    deleteMeetingRequest(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'delete-meeting-request/'+data,{headers:webheader})
    }

    getCirclewiseIpdCounts()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-circle-wise-ipd-count', {headers:webheader});
    }
    getCircleCategorywiseIpdCounts()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-circle-category-wise-ipd-count', {headers:webheader});
    }
    getCategorywiseIpdCounts()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-category-wise-ipd-count', {headers:webheader});
    }
    getCorporateRetailLeadsCount()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-corporate-retail-lead-count', {headers:webheader});
    }
    getCorporateRetailLeadsCountStatusWise()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-corporate-retail-lead-count-status-wise', {headers:webheader});
    }
    getCorporateRetailCountPartnerWise()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-corporate-retail-lead-count-partner-wise', {headers:webheader});
    }
    getCorporateRetailCountPartnerWiseLeadSource()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-corporate-retail-lead-count-partner-wise-lead-source', {headers:webheader});
    }
    getCorporatePartnerStatusWise()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-corporate-lead-status-wise', {headers:webheader});
    }
    getCorporatePartnerStatusWiseLeadSource()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-corporate-lead-status-wise-lead-source', {headers:webheader});
    }
    getMeetingsByTimeandDate(getdate)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-all-today-booked-data/'+getdate, {headers:webheader});
    }

    sendPreOperativeMessage()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'send-pre-op-message', {headers:webheader});
    }
    sendPostOperativeMessage()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'send-post-op-message', {headers:webheader});
    }

    markAsElective(ipd_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'mark-elective-ipd/'+ipd_id,{},{headers:webheader})
    }

    fetchHospitalAmountData(lead_id, insurance_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'fetch-hospital-amount/'+lead_id+'/'+insurance_id,{headers:webheader})
    }

    hospitalAmountDeleted(hospital_amount_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'delete-hospital-amount/'+hospital_amount_id,{headers:webheader})
    }

    getGlamyoHealthPartnersLeadsSheet(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-glamyo-health-partner-sheet/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    share_app_link(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'share-app-link',lead_id,{headers:webheader})
    }

    share_lab_lead_app_link(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'share-lab-lead-app-link',lead_id,{headers:webheader})
    }

    sendMobileViewotp(catId,leadId) {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'send-mobile-view-otp/'+catId+'/'+leadId,{headers:webheader})
    }

    verifyOtp(otp,leadId) {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'verify-otp-of-mobile-view/'+otp+'/'+leadId, {headers:webheader})
    }

    showmobilenumber(leadId) {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'show-mobile-number/'+leadId, {headers:webheader})
    }

    getLeadsWithCallRecording(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-leads-with-call-recording/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    } 
    
    share_plans(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'share-health-plan',data,{headers:webheader})
    }

    share_payment_link(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'send-razorpay-payment-link',data,{headers:webheader})
    }

    savePrescriptionOpdFor(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-opd-Prescription',data,{headers:webheader})
    }
//---------Plan-Lead-List---------//
    getPlanLeadList(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-plan-lead-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }
    getplanEditData(data)
    {
        let plan_id = data;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-update-plan-lead-data/'+plan_id,{headers:webheader})
    }
    updatePlanLead(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-plan-lead',data,{headers:webheader})
    }

//---------Partner-Leads-List---------//

    getPartnerLeadList(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-partner-leads-sheet/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }
    updatePartnerLeadData(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'update-partner-lead-data',data,{headers:webheader})
    }
    uploadLeadcsv(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-partner-lead-csv',data,{headers:webheader})
    }

    getPartnerLeadDetails(data)
    {
        let lead_id = data.lead_id.id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-move-partner-lead-details/'+lead_id,{headers:webheader})
    }

    kaleyraClickTOCallForPartnerLeads(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'kaleyra-click-to-call-for-partner-leads',lead_id,{headers:webheader})
    }

    kaleyraEndClicktoCallForPartnerLeads(response_call_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'kaleyra-end-click-to-call-for-partner-leads',response_call_id,{headers:webheader})
    }

    getMdSpokUsers(source)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-mdspok-users/'+source,{headers:webheader})
    }
//----------------opd-ipd-click-to-call----------------------//
    OpdIpdClickTOCall(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'opd-ipd-click-to-call',lead_id,{headers:webheader})
    }

//----------------Ipd-opd-call-Deatils-----------------------//
    getIpdOpdCallDetails(data)
    {
        let lead_id = data;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-ipd-opd-call-details/'+lead_id,{headers:webheader})
    }

    uploadcsvLeadFollowupUpdate(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-followUp-data',data,{headers:webheader})
    }

    checkMobileNumber(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'check-mobile-already-exists',data,{headers:webheader})
    }

    updateOpdAssignee(userId:number, opdId:number)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.patch(apiUrl+'update-opd-assignee/'+opdId, {userId:userId}, {headers:webheader});
    }

    updateIpdAssignee(userId:number, ipdId:number)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.patch(apiUrl+'update-ipd-assignee/'+ipdId, {userId:userId}, {headers:webheader});
    }

    getFeedbackUsers(status=1)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-feedBackUsers/'+status,{headers:webheader})
    }

    getCategorywiseAllIpdsCounts()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-category-wise-all-ipds-count', {headers:webheader});
    }

    getFeedBackReportCount()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-feedback-report-count', {headers:webheader});
    }
    uploadcsvOtherLeads(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-other-source-leads',data,{headers:webheader})
    }

    //----------------Update Lead Details----------------------//
    saveEditLeadDetails(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'save-edit-lead-details',data,{headers:webheader})
    }

    saveMdspockDescription(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'save-mdspock-description',data,{headers:webheader})
    }

    //----------------Ipd Patient Journey Details----------------------//
    getIpdPatientJourneyDetails(ipd_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-ipd-patient-journey-details/'+ipd_id,{headers:webheader})
    }

    //----------------Update Admin Lead Details----------------------//
    saveAdminUpdateLeadDetails(data)
     {
         let webheader = this.sharedapi.getHeaders();
         return this.http.post(apiUrl+'save-update-admin-lead-details',data,{headers:webheader})
     }

     getAffiliateUserLeads(pageno,limit,qstring)
     {
         let webheader = this.sharedapi.getHeaders();
         return this.http.get(apiUrl+'get-affiliate-leads/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
     }

     getAffiliateOpds(pageno,limit,qstring)
     {
         let webheader = this.sharedapi.getHeaders();
         return this.http.get(apiUrl+'get-affiliate-opds/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
     }

     getAffiliateIpds(pageno,limit,qstring)
     {
         let webheader = this.sharedapi.getHeaders();
         return this.http.get(apiUrl+'get-affiliate-ipds/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
     }

     getProductLeadDetail(lead_id)
     {
         let webheader = this.sharedapi.getHeaders();
         return this.http.get(apiUrl+'get-product-lead-details/'+lead_id,{headers:webheader})
     }

     getSexualWellnessTreatments()
     {
         let webheader = this.sharedapi.getHeaders();
         return this.http.get(apiUrl+'get-sexual-wellness-treatment',{headers:webheader})
     }

     //----------------Push Data To Nimbus----------------------//
     getPushDataToNimbus(qstring)
     {
         let webheader = this.sharedapi.getHeaders();
         return this.http.get(openapiUrlServ+'push-data-to-nimbus?'+qstring,{headers:webheader})
     }
   
     getLeadsForWhatsAppMessage(qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-leads-whatsapp-message?'+qstring,{headers:webheader})
    }

    getProductClinics()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-product-clinics',{headers:webheader})
    }
    
    //----------------Feedback Description----------------------//
    addFeedbackDescription(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'save-feedback-description',data,{headers:webheader})
    }

    getProductDetail(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-product-detail/'+lead_id,{headers:webheader})
    }

    getHospitalOrClinic(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-hospital-clinic-typewise?'+data,{headers:webheader})
    }

    getDentalProUsers()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-pro-users',{headers:webheader})
    }

    uploadIpdSharesCsv(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-ipd-shares-csv',data,{headers:webheader})
    }

    uploadOpdSharesCsv(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-opd-shares-csv',data,{headers:webheader})
    }

    getOverAllRevenueCategorywise(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-overAll-revenue-category-wise?'+data, {headers:webheader});
    }

    getAccountsUsers(status=1)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-accountsUsers/'+status,{headers:webheader})
    }
}
